angular.module('account').controller('AccountValidationCtrl',
    ['$scope', '$stateParams', 'ListService', 'toaster', 'aprgettext', 'TransitionManager', 'SessionService',
        function ($scope, $stateParams, ListService, toaster, gettext, TransitionManager, SessionService) {
            'use strict';

            $scope.loading = false;
            $scope.accountValidationDto = {
                DriversLicenseNumber: '',
                DriversLicenseState: ''
            };

            $scope.back = function back(){

                SessionService.setDisplayDashboardToolbar(false);
                TransitionManager.transition({appRoute: 'login'});
            };
            $scope.next = function next(){
                TransitionManager.transition({appRoute: 'accountsetup'});
            };

        }]);


